<template>
  <div v-if="developmentStore.developmentData && developmentStore.developmentData.hits" class="development-search">
    <!-- Results Count -->
    <div class="__results-info-raw">
      <span>{{ developmentResultStats }}</span>
    </div>

    <!-- Builder only warning -->
    <!--    <span v-if="builderName" class="__builder-development-only-notice"><strong>Important!</strong> Showing only {{ builderName }}'s developments. Go back to <nuxt-link to="/development/search">all development search</nuxt-link>.</span>-->

    <!-- Development Items -->
    <div v-if="developmentWithAds && developmentWithAds.length >= 0" class="row justify-content-center __listing-items-wrapper">
      <div v-for="(hit, key) in developmentWithAds" :key="`development-${key}`" :class="developmentStore.viewType === 'Map' ? 'col-md-12 col-lg-6' : 'col-sm-6 col-md-4 col-lg-3'" class="d-flex justify-content-center development-widget-item-wrapper">
        <DevelopmentWidget v-if="hit.document && hit.document.category !== 'Ad'" :development="hit.document" :analytics-event-data="{searchResultId: developmentStore.requestId, position: getPosition(key), displayedLocation: 'development search'}" />
        <AdWidget v-else :listing="hit.document" max-height="405px" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useDevelopmentStore} from '~/store/development';
import {Ref} from 'vue';
import {Listing} from '~/@types/listing';

// DATA Definitions
//----------------------------------------------------------------------------------------------------------------------
const developmentStore = useDevelopmentStore();
const {$ad} = useNuxtApp();
const ads: Ref<{document: Listing}[]> = ref([]);

/**
 * Development result stats
 */
const developmentResultStats: ComputedRef<string> = computed(() => {
  if (developmentStore && developmentStore.developmentData && developmentStore.developmentData.request_params) {
    const foundResults = developmentStore.developmentData.found > 500 ? '500+' : developmentStore.developmentData.found;
    const upToResults =developmentStore.developmentData.page * developmentStore.developmentData.request_params.per_page;
    return `Page ${developmentStore.developmentData.page} (Showing ${((developmentStore.developmentData.page - 1) * developmentStore.developmentData.request_params.per_page) + 1} - ${upToResults > foundResults ? foundResults : upToResults } Development of ${ foundResults } Results)`;
  }
  return '';
});

/**
 * @_MOUNTED Hook
 */
onMounted(() => {
  getAds();
});

/**
 * Get ads
 */
async function getAds () {
  const response = await $ad.search(['developments']);
  if (response && response.hits) {
    ads.value = response.hits;
  }
}

/**
 * Get the position of this listing in the search results
 * @param key
 */
function getPosition (key: number) {
  return (developmentStore.developmentData.page - 1) * developmentStore.developmentData.request_params.per_page + key + 1;
}

const developmentWithAds: ComputedRef<any[]> = computed(() => {
  const mergedArray: any[] = [];

  if (developmentStore.developmentData && developmentStore.developmentData.hits) {
    let adIndex = 0;
    let adsInserted = 0;

    developmentStore.developmentData.hits.forEach((hit, index) => {
      // Add the development item
      mergedArray.push(hit);

      // Insert the first ad after the 2nd item (to be the 3rd), then after every 3 items
      if ((adsInserted === 0 && index === 2) || (adsInserted > 0 && (index - adsInserted * 3) === 2)) {
        if (adIndex < ads.value.length) {
          mergedArray.push(ads.value[adIndex]);
          adIndex++;
          adsInserted++;
        }
      }
    });
  }

  return mergedArray;
});
</script>

<style lang="scss">
.development-search {
  padding: 30px;


  .development-widget-item-wrapper {
    padding-bottom: 30px;
  }

  .__development-search-action-raw {
    display: flex;

    // Action row dropdown
    .el-input-dropdown.__sort-by-dropdown {
      min-width: 100px;
      max-width: 180px;
      background: rgb(var(--background-light));
      box-shadow: 0 1px 12px -3px rgba(0, 0, 0, 0.15);
      border-radius: 8px;
      padding: 5px;
      min-height: unset;
      height: 40px;
      margin-right: 12px;

      .__dropdown-label {
        color: rgb(var(--text-lighter-1));
        margin-bottom: 0;
        font-weight: 400;
        padding: 0 12px;
        font-size: 14px;
      }

      .__input-dropdown-inner {
        min-height: unset;

        .__selection {
          color: rgb(var(--background-dark));
          font-size: 14px;
          margin-top: -2px;
        }

        .__inner-icon {
          position: absolute;
          right: 8px;
          top: 12px;
        }
      }

      .__dropdown-items-wrapper {
        left: 0;
        top: 38px;
      }
    }

    .__view-selector-placeholder {
      width: 480px;
    }
  }

  .__builder-development-only-notice {
    display: block;
    width: 100%;
    text-align: center;
    padding: 0px 5px 20px;
    font-size: 14px;

    strong {
      font-weight: 500;
    }
  }

  .__results-info-raw {
    min-height: 12px;
    margin: 50px 0 20px;
    text-align: right;
    font-size: 14px;
    color: rgb(var(--text-lighter-1));
  }
}
</style>
